import { PaymentStatus as Status } from '../constants';

const deadEnds = [
  Status.failed,
  Status.accepted,
  Status.cancelled,
];

const transitions = [
  Status.sending,
  Status.confirmingSend,
  Status.accepting,
  Status.confirmingAccept,
  Status.cancelling,
  Status.confirmingCancel,
];

class PaymentStatus {
  constructor(status) {
    if (!status) throw new Error('Invalid status passed');
    this.status = status;
  }

  is(status) {
    if (!status) throw new Error('Invalid status passed');
    return this.status === status;
  }

  isAcceptable() {
    return this.status === Status.pending;
  }

  isCancellable() {
    return this.status === Status.pending;
  }

  isRemovable() {
    return this.status === Status.failed || this.status === Status.confirmingSend;
  }

  isTransitional() {
    return transitions.indexOf(this.status) !== -1;
  }

  isPending() {
    return deadEnds.indexOf(this.status) === -1;
  }

  toString() {
    return this.status;
  }
}

export const PaymentStatuses = Status;
export { PaymentStatus };
export default status => new PaymentStatus(status);



// WEBPACK FOOTER //
// ./src/utilities/PaymentStatus.js